// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_RemoverInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/production_steps/remover
 *
 * Soft-delete a production step.
 */
import { registerContract } from './validate'

export interface ProductionSteps_RemoverInput {
so_production_step_id: number
}

registerContract('ProductionSteps_RemoverInput', {
  so_production_step_id: { type: 'number',  required: true },
})
